module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/email.eebfa2da769bf5740f777c7d312f3d74.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/email.svg
// module id = 1666
// module chunks = 1